(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bag-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thailiwale-bag-calculator')) {
    customElements.define('thailiwale-bag-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.form = this.querySelector('form');
        this.calculate = this.form.querySelector('button[type="submit"]');
        this.checkout = this.querySelector('[data-checkout]');
        this.result = this.querySelector('.tw-calculator__result');
        this.status = this.querySelector('[role="status"].tw-calculator__status');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: 'INR' });
        this.pinStatus = this.querySelector('[data-pin-status]');
        this.previewImage = this.querySelector('[data-bag-preview]');
        const previewMap = this.querySelector('[data-preview-map]');
        this.previewMap = previewMap ? JSON.parse(previewMap.textContent) : null;
        this.form.addEventListener('input', event => {
          this.invalidate();
          if (event.target.name === 'postcode') {
            this.pinRequest?.abort(); clearTimeout(this.pinTimer);
            this.form.elements.state.value = '';
            this.pinStatus.textContent = '';
            if (/^[1-9]\d{5}$/.test(event.target.value)) this.pinTimer = setTimeout(() => this.resolvePin(), 350);
          }
        });
        this.form.querySelectorAll('[name="standardSize"]').forEach(input => input.addEventListener('change', () => this.selectSize()));
        this.form.elements.bagColour?.addEventListener('change', () => this.updatePreview());
        this.form.elements.colours.addEventListener('change', () => this.updatePreview());
        this.selectSize();
        this.updatePreview();
        this.form.addEventListener('change', () => this.invalidate());
        this.form.addEventListener('submit', event => { event.preventDefault(); this.getQuote(); });
        this.checkout.addEventListener('click', () => this.openCheckout());
      }
      disconnectedCallback() { this.request?.abort(); this.pinRequest?.abort(); clearTimeout(this.pinTimer); clearTimeout(this.expiryTimer); }
      selectSize() {
        const selected = this.form.elements.standardSize.value;
        const match = selected.match(/^\s*(\d+(?:\.\d+)?)\s*[*x×]\s*(\d+(?:\.\d+)?)(?:\s*\([^)]*\))?\s*$/i);
        const custom = selected === 'custom' || !match;
        this.querySelectorAll('[data-custom-size]').forEach(label => { label.hidden = !custom; });
        if (match) { this.form.elements.width.value = match[1]; this.form.elements.height.value = match[2]; }
      }
      colourKey() {
        return String(this.form.elements.bagColour?.value || 'white').toLowerCase().replace(/[^a-z0-9]/g, '');
      }
      updatePreview() {
        if (!this.previewImage || !this.previewMap) return;
        const key = this.colourKey();
        const printing = this.form.elements.colours;
        const supportsExtended = key === 'white' || key === 'ivory';
        Array.from(printing.options).forEach(option => {
          option.disabled = Number(option.value) > 2 && !supportsExtended;
        });
        if (printing.selectedOptions[0]?.disabled) printing.value = '2';
        const source = this.previewMap[key]?.[printing.value] || this.previewMap.white?.[printing.value] || this.previewMap.white?.['0'];
        if (source && this.previewImage.src !== source) {
          this.previewImage.style.opacity = '.35';
          this.previewImage.addEventListener('load', () => { this.previewImage.style.opacity = '1'; }, { once: true });
          this.previewImage.src = source;
        }
      }
      async resolvePin() {
        this.pinRequest?.abort();
        const pin = this.form.elements.postcode.value;
        if (!/^[1-9]\d{5}$/.test(pin)) return;
        const controller = new AbortController(); this.pinRequest = controller;
        this.pinStatus.textContent = this.dataset.pinBusy;
        try {
          const result = await this.post('postcode', { postcode: pin }, controller.signal);
          if (controller.signal.aborted || this.form.elements.postcode.value !== pin) return;
          if (result.postcode !== pin || typeof result.state !== 'string' || !result.state) throw new Error('invalid_pin');
          this.form.elements.state.value = result.state;
          this.pinStatus.textContent = '';
        } catch {
          if (!controller.signal.aborted) { this.form.elements.state.value = ''; this.pinStatus.textContent = this.dataset.pinFailure; }
        }
      }
      invalidate() {
        this.request?.abort();
        clearTimeout(this.expiryTimer);
        this.quoteToken = null;
        this.result.hidden = true;
        this.checkout.disabled = true;
        this.calculate.disabled = false;
        this.calculate.textContent = this.dataset.calculateLabel;
        this.status.textContent = '';
      }
      async post(path, body, signal) {
        const response = await fetch('/apps/thailiwale-custom-bags/' + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), signal });
        if (!response.ok) throw new Error('request_failed');
        return response.json();
      }
      async getQuote() {
        this.invalidate();
        if (this.dataset.enabled !== 'true') { this.status.textContent = this.dataset.unavailableLabel; return; }
        if (!this.form.reportValidity()) return;
        const fields = Object.fromEntries(new FormData(this.form));
        const controller = new AbortController();
        this.request = controller;
        this.calculate.disabled = true;
        this.calculate.textContent = this.dataset.busyLabel;
        try {
          const result = await this.post('quote', { productId: this.dataset.productId, size: fields.width + 'x' + fields.height, gsm: Number(fields.gsm), quantity: Number(fields.quantity), colours: Number(fields.colours), bagColour: fields.bagColour, postcode: fields.postcode }, controller.signal);
          if (controller.signal.aborted) return;
          this.form.elements.state.value = result.state;
          this.pinStatus.textContent = '';
          const values = [result.subtotalPaise, result.estimatedGstPaise, result.shippingTotalPaise, result.estimatedGrandTotalPaise];
          const expiresIn = Date.parse(result.expiresAt) - Date.now();
          if (values.some(value => !Number.isSafeInteger(value) || value < 0) || values[0] <= 0 || values[3] !== values[0] + values[1] + values[2] || !Number.isFinite(expiresIn) || expiresIn <= 0 || expiresIn > 3600000) throw new Error('invalid_quote');
          this.querySelector('[data-subtotal]').textContent = this.money.format(values[0] / 100);
          this.querySelector('[data-tax]').textContent = this.money.format(values[1] / 100);
          this.querySelector('[data-shipping]').textContent = this.money.format(values[2] / 100);
          this.querySelector('[data-total]').textContent = this.money.format(values[3] / 100);
          this.quoteToken = typeof result.quoteToken === 'string' ? result.quoteToken : null;
          this.result.hidden = false;
          this.checkout.disabled = result.checkoutReady !== true || !this.quoteToken;
          if (this.checkout.disabled) this.status.textContent = this.dataset.checkoutPendingLabel;
          this.expiryTimer = setTimeout(() => { this.invalidate(); this.status.textContent = this.dataset.expiredLabel; }, expiresIn);
        } catch (error) {
          if (!controller.signal.aborted) this.status.textContent = this.dataset.failureLabel;
        } finally {
          if (this.request === controller) { this.calculate.disabled = false; this.calculate.textContent = this.dataset.calculateLabel; }
        }
      }
      async openCheckout() {
        if (!this.quoteToken || this.checkout.disabled) return;
        const token = this.quoteToken;
        const controller = new AbortController();
        this.request = controller;
        this.checkout.disabled = true;
        try {
          const result = await this.post('checkout', { quoteToken: token }, controller.signal);
          if (controller.signal.aborted || this.quoteToken !== token) return;
          const url = new URL(result.checkoutUrl);
          if (url.protocol !== 'https:' || url.username || url.password || ![location.hostname, this.dataset.shopDomain].includes(url.hostname) || url.port) throw new Error('invalid_checkout');
          location.assign(url.href);
        } catch (error) {
          if (!controller.signal.aborted) { this.status.textContent = this.dataset.failureLabel; this.checkout.disabled = false; }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
